import { Nav } from 'react-bootstrap';
import { useEffect } from 'react';

import '../styles/SettingsLeftnav.css';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../store';
import { SystemPermission } from '../../../../context';
import {
  SettingsLeftNavbarMedicationSubTabs,
  SettingsLeftNavbarTabs,
} from '../types';
import preferencesSettings from '../../../../assets/img/preferences-settings.png';
import systemSetting from '../../../../assets/img/system-settings.png';
import medicationProfileSettings from '../../../../assets/img/medication-profile-settings.png';

interface SettingsLeftNavbarProps {
  activeTab: SettingsLeftNavbarTabs;
  setActiveTab: (tab: SettingsLeftNavbarTabs) => void;
}
export const SettingsLeftNavbar = ({
  activeTab,
  setActiveTab,
}: SettingsLeftNavbarProps) => {
  const location = useLocation();

  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const canUseSystemSettings =
    !selectedTenancy?.permissionsSetup ||
    (selectedTenancy.permissionsSetup &&
      selectedTenancy?.userPermissions &&
      (!!(selectedTenancy?.userPermissions)[
        SystemPermission.MANAGE_PERMISSION
      ] ||
        !!(selectedTenancy?.userPermissions)[SystemPermission.ASSIGN_ROLE] ||
        !!(selectedTenancy?.userPermissions)[SystemPermission.MANAGE_TASK]));

  const canUsePreferences = selectedTenancy?.features?.automedicView;

  const canUseMedicationProfileSettings =
    !selectedTenancy?.permissionsSetup ||
    (selectedTenancy.permissionsSetup &&
      selectedTenancy?.userPermissions &&
      !!(selectedTenancy?.userPermissions)[
        SystemPermission.VIEW_MEDICINE_CATALOG
      ]);

  // Ensure active tab is accessible, otherwise redirect to no access
  useEffect(() => {
    if (activeTab === SettingsLeftNavbarTabs.PREFERENCE && !canUsePreferences) {
      if (canUseSystemSettings) {
        setActiveTab(SettingsLeftNavbarTabs.SYSTEM_SETTINGS);
      } else if (canUseMedicationProfileSettings) {
        setActiveTab(SettingsLeftNavbarTabs.MEDICATION_PROFILE_SETTINGS);
      } else {
        setActiveTab(SettingsLeftNavbarTabs.NO_ACCESS);
      }
    }
  }, [
    activeTab,
    canUsePreferences,
    canUseSystemSettings,
    canUseMedicationProfileSettings,
    setActiveTab,
  ]);

  return (
    <aside className="navbarLeft-container">
      <Nav className="flex-column settings-left-navbar">
        {canUsePreferences && (
          <Nav.Item>
            <Nav.Link
              href={`#${SettingsLeftNavbarTabs.PREFERENCE}`}
              className={
                activeTab === SettingsLeftNavbarTabs.PREFERENCE
                  ? 'active'
                  : 'inactive'
              }
              onClick={() => setActiveTab(SettingsLeftNavbarTabs.PREFERENCE)}
            >
              <img src={preferencesSettings} alt="Preferences icon" />
              Preferences
            </Nav.Link>
          </Nav.Item>
        )}
        {canUseSystemSettings && (
          <Nav.Item>
            <Nav.Link
              href={`#${SettingsLeftNavbarTabs.SYSTEM_SETTINGS}`}
              className={
                activeTab === SettingsLeftNavbarTabs.SYSTEM_SETTINGS
                  ? 'active'
                  : 'inactive'
              }
              onClick={() =>
                setActiveTab(SettingsLeftNavbarTabs.SYSTEM_SETTINGS)
              }
            >
              <img src={systemSetting} alt="System settings icon" />
              System settings
            </Nav.Link>
          </Nav.Item>
        )}
        {canUseMedicationProfileSettings && (
          <Nav.Item className="sub-items">
            <Nav.Link
              href={`#${SettingsLeftNavbarTabs.MEDICATION_PROFILE_SETTINGS}-med-catalogue`}
              className={
                activeTab === SettingsLeftNavbarTabs.MEDICATION_PROFILE_SETTINGS
                  ? 'active'
                  : 'inactive'
              }
              onClick={() =>
                setActiveTab(SettingsLeftNavbarTabs.MEDICATION_PROFILE_SETTINGS)
              }
            >
              <img
                src={medicationProfileSettings}
                alt="Medication Profile settings icon"
              />
              Medication Profile settings
            </Nav.Link>
            {activeTab ===
            SettingsLeftNavbarTabs.MEDICATION_PROFILE_SETTINGS ? (
              <>
                <Nav.Link
                  className={`${
                    activeTab ===
                    SettingsLeftNavbarTabs.MEDICATION_PROFILE_SETTINGS
                      ? 'active'
                      : 'inactive'
                  } sub-item`}
                  href={`#${SettingsLeftNavbarMedicationSubTabs.MEDICATION_PROFILE_SETTINGS_MED}`}
                >
                  <span
                    className={`${location.hash === '#' + SettingsLeftNavbarMedicationSubTabs.MEDICATION_PROFILE_SETTINGS_MED ? 'active-sub-item' : 'inactive-sub-item'}`}
                  >
                    Medication catalogue
                  </span>
                </Nav.Link>
                <Nav.Link
                  className={`${
                    activeTab ===
                    SettingsLeftNavbarTabs.MEDICATION_PROFILE_SETTINGS
                      ? 'active'
                      : 'inactive'
                  } sub-item`}
                  href={`#${SettingsLeftNavbarMedicationSubTabs.MEDICATION_PROFILE_SETTINGS_ORDER}`}
                >
                  <span
                    className={`${location.hash === '#' + SettingsLeftNavbarMedicationSubTabs.MEDICATION_PROFILE_SETTINGS_ORDER ? 'active-sub-item' : 'inactive-sub-item'}`}
                  >
                    Order sets
                  </span>
                </Nav.Link>
              </>
            ) : null}
          </Nav.Item>
        )}
      </Nav>
    </aside>
  );
};
